import { createContext, ReactElement, ReactNode, useState } from "react";
import { Dialog, DialogActions, DialogContent, IconButton } from "@mui/material";
import { Check, Close } from "@mui/icons-material";

export interface Props
{
    children: ReactElement
}
const ConfirmContext = createContext<(content: ReactNode) => Promise<void>>(() => { return Promise.reject() });
export default function ConfirmProvider({ children }: Props)
{
    const [confirmContent, setContent] = useState<ReactNode>(null);
    const [actions, setActions] = useState({
        confirm: () => { setContent(null); },
        reject: () => { setContent(null); }
    });


    const confirmPromise = (content: ReactNode) =>
    {
        return new Promise<void>((resolve, reject) =>
        {
            setContent(content);
            setActions({
                confirm: () =>
                {
                    resolve();
                    setContent(null);
                },
                reject: () =>
                {
                    reject();
                    setContent(null);
                }
            });
        })
    }

    return <>
        <ConfirmContext.Provider value={confirmPromise}>
            <>
                <Dialog open={confirmContent !== null}>
                    <DialogContent>
                        {confirmContent}
                    </DialogContent>
                    <DialogActions>
                        <IconButton onClick={actions.confirm}>
                            <Check />
                        </IconButton>
                        <IconButton onClick={actions.reject}>
                            <Close />
                        </IconButton>
                    </DialogActions>
                </Dialog>
                {children}
            </>
        </ConfirmContext.Provider>
    </>
};
export { ConfirmContext };